<template>
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
      <div class="relative rounded-2xl shadow-xl p-8 max-w-md w-full bg-[#E9EBEC] flex flex-col items-center">
        <button v-if="showCloseButton" @click="hide" class="absolute top-4 right-4 text-accent hover:text-accent-dark">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div v-if="type === 'success'" class="mb-4">
          <svg class="w-10 h-10 mx-auto" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#3CB371"/><path d="M13 21l5 5 9-11" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <div v-else-if="type === 'warning'" class="mb-4">
          <svg class="w-10 h-10 mx-auto" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#E3C47A"/><text x="20" y="27" text-anchor="middle" font-size="22" fill="#06474D" font-family="Arial">!</text></svg>
        </div>
        <div v-else class="mb-4">
          <svg class="w-10 h-10 mx-auto" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#E3C47A"/><path d="M14 14l12 12M26 14l-12 12" stroke="#06474D" stroke-width="3" stroke-linecap="round"/></svg>
        </div>
        <h2 v-if="title" class="font-bebas text-xl text-accent mb-2 text-center">{{ title }}</h2>
        <p class="font-didact text-accent text-center text-base mb-2">{{ message }}</p>
        <div class="flex gap-2 justify-center mt-2">
          <slot name="actions" :hide="hide"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'

const props = defineProps({
  type: { type: String, default: 'success' }, // 'success', 'error', 'warning'
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  duration: { type: Number, default: 3000 }, // ms, 0 = nie znika sam
  autoClose: { type: Boolean, default: true }, // czy ma się zamykać automatycznie
  showCloseButton: { type: Boolean, default: true } // czy pokazywać przycisk zamykania
})

const emit = defineEmits(['close'])
const visible = ref(false)

function show() {
  visible.value = true
  if (props.autoClose && props.duration > 0) {
    setTimeout(() => { 
      visible.value = false
      emit('close')
    }, props.duration)
  }
}

function hide() {
  visible.value = false
  emit('close')
}

watch(() => props.message, (val) => {
  if (val) {
    show()
  }
})

onMounted(() => {
  if (props.message) {
    show()
  }
})

// Umożliw globalne użycie przez expose
defineExpose({ show, hide })
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style> 